import React from 'react';
import { styled } from '../../themes';

import Link from '../link';

interface Props {
  label: string,
  to: string,
}

const Button = (props: Props) => {
  const { label, to, ...rest } = props;
  return (
    <StyledButton to={to} {...rest}>
      {label}
    </StyledButton>
  );
};

const StyledButton = styled(Link)`
  &,
  &:link,
  &:visited {
    position: relative;
    text-decoration: none;
    padding: 1rem 4rem;
    width: ${({ fullWidth }) => (fullWidth ? '100%' : 'min-content')};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    transition: all 0.2s;
    font-size: 2rem;
    font-weight: 700;
    color: white;
    white-space: nowrap;
    background-image: ${({ theme }) =>
      `linear-gradient(258deg, ${theme.colors.orange}, ${theme.colors.darkOrange})`};
    box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.2);
    user-select: none;
    border: none;
    cursor: pointer;
  }

  &:hover {
    transform: translateY(-0.3rem);
    box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.2);

    &::after {
      transform: scaleX(1.4) scaleY(1.6);
      opacity: 0;
    }
  }

  &:active,
  &:focus {
    outline: none;
    transform: translateY(0.1rem);
  }
`;

export default Button;
